import React from 'react'
import { connect } from 'react-redux';
import { TrashIcon } from '@primer/octicons-react';

import { deleteModule } from '../../actions/modules';

class DeleteModuleButton extends React.Component {
  handleDelete(event) {
    event.preventDefault()

    const { dispatch, module } = this.props;

    dispatch(deleteModule(module.uuid));

    event.stopPropagation()
  }

  render() {
    return (
      <button
        className="outline-none"
        onClick={this.handleDelete.bind(this)}>
        <TrashIcon />
      </button>
    );
  }
}

export default connect()(DeleteModuleButton);
